import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import ObservationRepository from '@/shared/http/repositories/crm/observation'

import ObservationForm from './observation-form.js'

const ObservationData = {
  id: null,
  data: null,
  detalhes: null,
  ip: null,
  autor: null,
  cardId: null
}

export default {
  name: 'ModalAddObservation',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      document: null,
      data: ObservationData,
      form: ObservationForm
    }
  },
  watch: {
    card () {
      if (this.card && this.card.pessoa) {
        this.onSyncData()
      }
    }
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-new-observation'].show()
    },
    hideModal () {
      this.$refs['modal-new-observation'].hide()
    },
    onLoad () {
    },
    onReload () {
      this.$emit('Reload')
    },
    onSyncData () {
      if (this.card && this.card.pessoa) {
        this.document = this.card.pessoa.document
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onBack () {
      this.onClear()
      this.$emit('Reload')
    },
    onCreate () {
      loading.push()
      this.data.id = 0
      this.data.document = this.card.pessoa.document.toString().replace(/[^\d]+/g, '')
      this.data.ip = this.ip
      this.data.cardId = this.card.id
      this.data.data = this.moment().format('YYYY-MM-DD') + 'T' + this.moment().format('HH:mm:ss')

      let formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      formData.append('data', json)

      ObservationRepository.Create(formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
          }
          loading.pop()
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.document = this.card.pessoa.document.toString().replace(/[^\d]+/g, '')
      this.data.ip = this.ip
      this.data.data = this.moment().format('YYYY-MM-DD') + 'T' + this.moment().format('HH:mm:ss')

      let formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      formData.append('data', json)

      ObservationRepository.Update(this.data.id, formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onBack()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onAddObs () {
      this.$refs.ModalAddObservation.showModal()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/observation/new/observation.js